export default "__VITE_ASSET__B7Clop8y__"